import React, { useEffect, useState, useRef } from "react";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faInfoCircle, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from 'react-bootstrap/Tooltip';
import { Link, navigate, useHistory } from "raviger";
import Location from "../../common/LocationV2";
import PageLoader from "../../shared/PageLoader";
import * as api from "../../../backend/request";
import { toast } from 'react-toastify';
import { ACTIONS, ACTIVITY_STATUS, AUDIT_STATUS, FILTERS, STATUS_MAPPING, TOOLTIP_DELAY } from "../../common/Constants";
import Icon from "../../common/Icon";
import Table, { reactFormatter, CellTmpl, TitleTmpl, DEFAULT_PAYLOAD } from "../../common/Table";
import { faSave } from "@fortawesome/free-regular-svg-icons";
import AdvanceSearch from "../../common/AdvanceSearch";
import AlertModal from "../../common/AlertModal";
import { download, downloadWithPresignedUrl, downloadFileContent, preventDefault, reduceArraytoObj } from "../../../utils/common";
import PublishModal from "./PublishModal";
import ActivityModal from "./ActivityModal";
import { getUserDetails, hasUserAccess } from "../../../backend/auth";
import { getAuditReportFileName, useAuditReport, useAuditReportForVendor } from "../../../backend/exports";
import { ACTIVITY_TYPE, ACTIVITY_TYPE_ICONS, API_DELIMITER, ERROR_MESSAGES } from "../../../utils/constants";
import { useExportTodos, useGetAllActivities } from "../../../backend/query";
import { USER_PRIVILEGES } from "../UserManagement/Roles/RoleConfiguration";
import TableActions, { ActionButton } from "../../common/TableActions";
import SendEmailModal from "./SendEmailModal";
import { saveAs } from 'file-saver';
import { AxiosError } from "axios";
import {
  AUDIT_STATUS_COLOR_CODES,
  AUDIT_STATUS as LOCATION_AUDIT_STATUS,
  AUDIT_STATUS_LABELS
} from "../../../utils/auditStateMachine";
import AuditLocationFilters from "../../common/AuditLocationFilters";
import AuditDetailsModal from "../Vendor/TaskManagement/AuditDetailsModal";
import { IconButton } from "@mui/material";
import { IoMdInformationCircleOutline } from "react-icons/io";

const STATUS_BTNS = [
    { name: ACTIVITY_STATUS.ACTIVITY_SAVED, label: STATUS_MAPPING[ACTIVITY_STATUS.ACTIVITY_SAVED], style: 'secondary' },
    { name: ACTIVITY_STATUS.PENDING, label: STATUS_MAPPING[ACTIVITY_STATUS.PENDING], style: 'warning' },
    { name: ACTIVITY_STATUS.OVERDUE, label: STATUS_MAPPING[ACTIVITY_STATUS.OVERDUE], style: 'danger' },
    { name: ACTIVITY_STATUS.SUBMITTED, label: STATUS_MAPPING[ACTIVITY_STATUS.SUBMITTED], style: 'danger' },
    { name: ACTIVITY_STATUS.REJECTED, label: STATUS_MAPPING[ACTIVITY_STATUS.REJECTED], style: 'danger' },
    { name: ACTIVITY_STATUS.AUDITED, label: STATUS_MAPPING[ACTIVITY_STATUS.AUDITED], style: 'danger' }
];

const SortFields: any = {
    'act.name': 'act_name',
    'rule.name': 'rule_name',
    'activity.name': 'activity_name',
    'activity.type': 'activity_activity_type',
    'associate_company.name': 'associate_company_name',
    'location.name': 'location_name'
};

const INCLUDE_ASSOCIATIONS = [
  'act','rule','activity','associate_company','location', 'company'
];
const INCLUDE_ASSOCIATION_COLUMNS = {
  act: { only: ['id','name'] },
  rule: { only: ['id','name'] },
  activity: { only: ['id','name','activity_type'] },
  associate_company: { only: ['id','name', 'code'] },
  company: { only: ['id','name', 'code'] },
  location: { only: ['id','name', 'code'] }
};

const include = ['company', 'associate_company', 'location', 'preliminary_report', 'final_report'];
const includes = ['company', 'associate_company', 'location', 'preliminary_report', 'final_report'];

function TaskManagement({ auditId }: any) {
    const { state }: any = useHistory();
    const [statusBtns] = useState(STATUS_BTNS);
    const [submitting, setSubmitting] = useState(false);
    const [checkedStatuses, setCheckedStatuses] = useState<any>({});
    const [activity, setActivity] = useState<any>(null);
    const [action, setAction] = useState<any>(null);
    const [data, setData] = useState<any>();
    const [params, setParams] = useState<any>();
    const [advaceSearchFilters, setAdvanceSearchFilters] = useState<any>({});
    const afRef: any = useRef();
    afRef.current = advaceSearchFilters;
    const [statusFilters, setStatusFilters] = useState<any>({
      status_in: STATUS_BTNS.map(x => x.name)
    });
    //console.log(statusFilters,'Statusfilters')
    const sfRef: any = useRef();
    sfRef.current = statusFilters;

    const [payload, setPayload] = useState<any>({
      includes: INCLUDE_ASSOCIATIONS,
      include: INCLUDE_ASSOCIATION_COLUMNS
    });

    const { activities, total, isFetching, refetch } = useGetAllActivities(payload, Boolean(hasFilters(null, 'location_audit_id_eq')));

    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [alertMessage, setAlertMessage] = useState<any>(null);
    const [publish, setPublish] = useState(false);
    const [currentAudit, setCurrentAudit] = useState<any>({});
    const [showAuditDetails, setShowAuditDetails] = useState(false);
    const [selectedReportForDownload, setSelectedReportForDownload] = useState<any>(null);
    const { auditReport, exporting } = useAuditReport(
      (response: any) => {
        if (response) {
            const filename = selectedReportForDownload && selectedReportForDownload.name ? selectedReportForDownload.name.charAt(0).toUpperCase() + selectedReportForDownload.name.slice(1) : 'audit_report';
          downloadFileContent({
            name: filename,
            type: response.headers["content-type"],
            content: response.data,
          });
        }
      },
      (error: any) => {
        console.log(error)
        toast.error(ERROR_MESSAGES.DEFAULT);
      }
    );

    const { exportTodos, exporting: exportingTodos } = useExportTodos((response: any) => {
        downloadFileContent({
            name: 'Audit Activities.xlsx',
            type: response.headers['content-type'],
            content: response.data
        });
    }, () => {
        toast.error(ERROR_MESSAGES.DEFAULT);
    });

    useEffect(() => {
        if (auditId) {
            refetchAudit();
        } else {
            navigate('/location-audits');
        }
    }, [auditId]);

    useEffect(() => {
        if (currentAudit && currentAudit.id) {
            setAdvanceSearchFilters({
                location_audit_id_eq: currentAudit.id
            });
        }
    }, [currentAudit]);

    async function refetchAudit() {
        if (auditId) {
            try {
                const response = await api.get(`/api/v1/location_audits/${auditId}`, {
                    include: include,
                    includes: includes
                });
                if (response && response.data) {
                    setCurrentAudit(response.data);
                }
            } catch (error) {
                console.error('Error refreshing audit:', error);
            }
        }
    }

    const buttons: ActionButton[] = [{
        label: 'Publish',
        name: 'publish',
        privilege: USER_PRIVILEGES.REVIEWER_ACTIVITIES_PUBLISH,
        action: () => publishActivity(null)
    },
    // {
    //     label: 'Send Report',
    //     name: 'email',
    //     action: () => setAction(ACTIONS.SEND_REPORT)
    // }
     ];

    const downloadReportButtons: ActionButton[] = [
        {
            label: "Preliminary Report",
            name: "preliminaryReport",
            privilege: USER_PRIVILEGES.REVIEWER_ACTIVITIES_DOWNLOAD_REPORT,
            action: () => {
                downloadReport(null, 'preliminary');
            },
        },
        {
            label: "Final Report",
            name: "finalReport",
            privilege: USER_PRIVILEGES.REVIEWER_ACTIVITIES_DOWNLOAD_REPORT,
            action: () => {
                downloadReport(null, 'final');
            },
        }
    ];

    function hasFilters(ref: any, field = 'location_audit_id_eq') {
        const _filters = (ref ? ref.current : (payload.filters || {}));
        return _filters[field];
    }

    function backToAuditList(event: any) {
        event.preventDefault();
        navigate('/location-audits', {
            state: {
                ...(state || {})
            }
        });
    }


    function downloadForm(activity: any) {
        setSubmitting(true);
        api.get(`/api/v1/act_state_mappings/${activity.act_state_mapping_id}`).then(response => {
            if (response.data.file_path) {
                downloadWithPresignedUrl(response.data.file_name, response.data.file_path)
            } else {
                toast.warn('No files available');
            }
        }).finally(() => setSubmitting(false));
    }

    function search(event: any) {
        const _filters: any = {
            location_audit_id_eq: (currentAudit || {}).id
        };
        const keys = Object.keys(event || {});
        if (keys.length > 0) {
            keys.forEach(key => {
                _filters[key] = event[key]
            });
        }
        setAdvanceSearchFilters(_filters);
    }

    function editActivity(activity: any) {
        setAction(ACTIONS.EDIT);
        setActivity(activity);
    }

    async function downloadReport(event: any, reportType: 'preliminary' | 'final') {
        preventDefault(event);
        if (currentAudit && currentAudit.id) {
            if(reportType == 'preliminary' && [LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_PENDING, LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED].includes(currentAudit.status)){
                toast.warn("Preliminary report is not available as Preliminary audit is not yet published.");
                return;
            }
            if(reportType == 'final' && [LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_PENDING, LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED, LOCATION_AUDIT_STATUS.FINAL_AUDIT_PENDING, LOCATION_AUDIT_STATUS.FINAL_AUDIT_SUBMITTED].includes(currentAudit.status)){
                toast.warn("Final report is not available as Final audit is not yet published.");
                return;
            }
            setSubmitting(true);
            try {
                let reportData: any;
                if(currentAudit && currentAudit.preliminary_report || currentAudit.final_report){
                    reportData = reportType == 'preliminary' ? currentAudit.preliminary_report : currentAudit.final_report;
                } else {
                    const response = await api.get(`/api/v1/location_audits/${currentAudit.id}`, {
                        include: include,
                        includes: includes
                    });
                    reportData = reportType == 'preliminary' ? response.data.preliminary_report : response.data.final_report;
                }
                setSelectedReportForDownload(reportData);

                const { s3_region, s3_key, s3_bucket } = reportData || {};
                if (s3_region && s3_key && s3_bucket) {
                    auditReport({
                        s3_region,
                        s3_key,
                        s3_bucket
                    });
                } else {
                    const reportTypeName = reportType.charAt(0).toUpperCase() + reportType.slice(1);
                    toast.warn(`${reportTypeName} report is not available`);
                }
            } catch (error) {
                console.error('Error fetching audit:', error);
            }
            setSubmitting(false);
        }
    }

    function dismissAction() {
        setAction(null);
        setActivity(null);
    }

    function publishActivity(e: any) {
        preventDefault(e);
        if(![LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED, LOCATION_AUDIT_STATUS.FINAL_AUDIT_SUBMITTED, LOCATION_AUDIT_STATUS.FINAL_AUDIT_EDITING, LOCATION_AUDIT_STATUS.FINAL_AUDIT_REPORT_FAILED].includes(currentAudit.status)) {
            toast.error("You cannot publish activities at this stage.");
        } else {
            setSubmitting(true);
            const _payload = {
                filters: {
                    location_audit_id_eq: currentAudit.id
                }
            };
            api.get('/api/v1/todos', _payload).then(response => {
                if (response && response.data) {
                    const _rows = (response.data || {data: {}}).items || [];
                    const auditableRows = _rows.filter((x: any) => [ACTIVITY_TYPE.AUDIT, ACTIVITY_TYPE.PHYSICAL_AUDIT].includes(x.auditted));
                    const submittedRows = auditableRows.filter((x: any) => [ACTIVITY_STATUS.SUBMITTED, ACTIVITY_STATUS.PENDING, ACTIVITY_STATUS.OVERDUE, ACTIVITY_STATUS.ACTIVITY_SAVED].includes(x.status));
                    const published = _rows.filter((x: any) => x.published);
                    if (_rows.length === 0) {
                        setAlertMessage(
                            `<p class="my-3">There are no activties available for the selected month and year.</p>`
                        );
                    } else if (published.length > 0 && ![LOCATION_AUDIT_STATUS.FINAL_AUDIT_REPORT_FAILED].includes(currentAudit.status)) {
                        setAlertMessage(
                            `<p class="my-3">All activites are published of the selected month and year. View Audit report for more details.</p>`
                        );
                    } else if (submittedRows.length > 0) {
                        setAlertMessage(
                            `<p class="my-3">There are ${submittedRows.length} activities not reviewed for the selected month and year.</p>
                            <p>Review them before publishing.</p>`
                        );
                    } else if (_rows.length > 0) {
                        setSelectedRows(_rows);
                        setPublish(true);
                    }
                }
            }).finally(() => setSubmitting(false));
        }
    }

    async function publishPreliminaryAudit(publishPayload: any) {
        setSubmitting(true);
        try {
            const newAuditStatus = LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_FINALIZED;
            const locationAuditId = currentAudit.id;
            let response: any = await api.put(`/api/v1/location_audits/${locationAuditId}/${newAuditStatus}`, publishPayload);
            if (response instanceof AxiosError) {
                toast.error("Failed to publish preliminary audit. Please try again.");
            } else {
                setTimeout(() => {
                    toast.success("Preliminary audit published successfully. Generating report...");
                    refetch();
                    refetchAudit();
                    setPublish(false);
                    setSubmitting(false);
                }, 2000);
            }
        } catch (error) {
            toast.error("Failed to publish audit.");
            console.error('Error publishing preliminary audit:', error);
            setPublish(false);
            setSubmitting(false);
        }
    }

    async function publishFinalAudit(publishPayload: any) {
        setSubmitting(true);
        try {
            const newAuditStatus = LOCATION_AUDIT_STATUS.FINAL_AUDIT_PUBLISHED;
            const locationAuditId = currentAudit.id;
            let response: any = await api.put(`/api/v1/location_audits/${locationAuditId}/${newAuditStatus}`, publishPayload);
            if (response instanceof AxiosError) {
                toast.error("Failed to publish final audit. Please try again.");
            } else {
                setTimeout(() => {
                    toast.success("Final audit published successfully. Generating report...");
                    refetch();
                    refetchAudit();
                    setPublish(false);
                    setSubmitting(false);
                }, 2000);
            }
        } catch (error) {
            toast.error("Failed to publish audit.");
            console.error('Error publishing final audit:', error);
            setPublish(false);
            setSubmitting(false);
        }
    }

    async function onPublish(e: any, recommendations: any, observations: any, treatAsFinalAudit: boolean = false) {
        preventDefault(e);
        const publishPayload = {
            recommendations: recommendations == "<div><br></div>" ? "" : recommendations,
            observations: observations == "<div><br></div>" ? "" : observations
        }
        if(treatAsFinalAudit || [LOCATION_AUDIT_STATUS.FINAL_AUDIT_SUBMITTED, LOCATION_AUDIT_STATUS.FINAL_AUDIT_EDITING, LOCATION_AUDIT_STATUS.FINAL_AUDIT_REPORT_FAILED].includes(currentAudit.status)){
            publishFinalAudit(publishPayload);
        } else {
            publishPreliminaryAudit(publishPayload);
        }
    }

    function onFormStatusChangeHandler(e: any) {
        setCheckedStatuses({
            ...(checkedStatuses || {}),
            [e.target.name]: e.target.checked
        });
    }

    function MonthTmpl({ cell }: any) {
        const row = cell.getData();
        return (
            <>{row.month} ({row.year})</>
        )
    }

    function DueDateTmpl({ cell }: any) {
        const value = cell.getValue();
        const { auditted = ACTIVITY_TYPE.AUDIT } = cell.getData();
        return (
            <>
                {
                    auditted !== ACTIVITY_TYPE.NO_AUDIT && value && value !== '0001-01-01T00:00:00' &&
                    <span className="text-warn" >{dayjs(value).format('DD-MM-YYYY')}</span>
                }
            </>
        )
    }


    function ActionHeaderTmpl() {
        return (
            <div className={`nav-item dropdown todoTableActions`}>
                <div className="nav-link text-white" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <FontAwesomeIcon icon={faEllipsisV} />
                </div>
                <div className="dropdown-menu">
                    <a className="dropdown-item" href="/" onClick={handleExport}>Export</a>
                    {/* removed this as api is not implemented */}
                     <a className="dropdown-item" href="/" onClick={bulkFileDownloadthroughZip}>All Files Download</a> 
                </div>
            </div>
        )
    
    }


    function bulkFileDownloadthroughZip(event: any) {
        event.preventDefault();

        const selectedStatuses = Object.keys(checkedStatuses)
        .filter((status) => checkedStatuses[status] === true) // Filter only the true values

        const filters = {
            location_audit_id_eq: currentAudit.id,
            status_in: selectedStatuses
        };

        event.preventDefault();
        const arrayOfData=data.data;
        let filtered = arrayOfData.filter((t: { id: string; })=>t.id);
        const todoIds = filtered.map((t: { id: string; }) => t.id);
        if(todoIds.length > 0){
            // API call to get the response with the x-uploaded-url header
            api.post('/api/v1/todo_details/bulk_download', {filters, todo_ids: todoIds}, {
                responseType: 'arraybuffer',
                headers: { 'Content-Type': 'application/zip' }
            }).then((response: any) => {
                if (response instanceof AxiosError) {
                    const contentType = response.response && response.response.headers['content-type'] || "";
                    if (contentType.includes('application/json')) {
                        const errorJson = (response.response || {}).data || {};
                        let error = (errorJson || {}).error|| [ERROR_MESSAGES.DEFAULT];
                        toast.warning(error);
                    }
                } else {
                    const {data} = response || {};
                    let respo = (data || { data: {} }).data;
                    if(respo.success) {
                        const urlMatch = respo.file_url;
                        if (urlMatch) {
                            const zipFileUrl = decodeURIComponent(urlMatch);
                            // Directly trigger download from the extracted URL
                            downloadWithPresignedUrl(`AuditActivities_${new Date().toISOString().split('T')[0]}.zip`, zipFileUrl);
                            toast.success("Zip FIle Downloaded");
                        }
                    } else {
                        toast.warning(respo.error);
                    }
                }
            }).catch((error : any) => {
                if (error instanceof AxiosError) {
                    const contentType = error.response && error.response.headers['content-type'] || "";
                    if (contentType.includes('application/json')) {
                        const errorJson = (error.response || {}).data || {};
                        let errorMessage = (errorJson || {}).error|| [ERROR_MESSAGES.DEFAULT];
                        toast.warning(errorMessage);
                    }
                } else {
                    console.error("Error downloading the file:", error);
                    toast.warning("Failed to download the ZIP files.");
                }
            });
        } else {
            toast.warning("There are no files available.");
        }
    }

    

    function FormStatusTmpl({ cell }: any) {
        const status = cell.getValue();
        const row = cell.getData();
        return (
            <div className="d-flex align-items-center position-relative">
                {!!row.forms_status_remarks && (
                    <OverlayTrigger
                        overlay={<Tooltip>
                            <div dangerouslySetInnerHTML={{ __html: row.forms_status_remarks }}></div>
                        </Tooltip>}
                        placement="bottom"
                        delay={{ show: TOOLTIP_DELAY } as any}
                    >
                        <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                    </OverlayTrigger>
                )}
                <span className={`status-${status} ellipse`}>
                    {STATUS_MAPPING[status] || status}
                </span>
            </div>
        );
    }

    function AuditStatusTmpl({ cell }: any) {
        const status = cell.getValue();
        const row = cell.getData();
        const color = {
            [AUDIT_STATUS.COMPLIANT]: 'status-compliant',
            [AUDIT_STATUS.NON_COMPLIANCE]: 'status-non-compliance',
            [AUDIT_STATUS.NOT_APPLICABLE]: 'status-not-applicable',
        };
        return (
            <div className="d-flex align-items-center position-relative">
                {!!row.audit_remarks && (
                    <OverlayTrigger
                        overlay={<Tooltip>
                            <div dangerouslySetInnerHTML={{ __html: row.audit_remarks }}></div>
                        </Tooltip>}
                        placement="bottom"
                        delay={{ show: TOOLTIP_DELAY } as any}
                    >
                        <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                    </OverlayTrigger>
                )}
                {status && (
                    <span className={`${color[status]} ellipse`}>
                        {STATUS_MAPPING[status] || status}
                    </span>
                )}
            </div>
        );
    }

    function ActionColumnElements({ cell }: any) {
        const row = cell.getData();

        return (
            <>
                {
                    row.auditted !== ACTIVITY_TYPE.NO_AUDIT &&
                    <div className="d-flex flex-row align-items-center position-relative">
                        <Icon className="mx-1" type="button" name="download" text="Download" data={row} action={downloadForm} />
                        {
                            ((row.auditted === ACTIVITY_TYPE.AUDIT
                                && [ACTIVITY_STATUS.SUBMITTED, ACTIVITY_STATUS.AUDITED, ACTIVITY_STATUS.REJECTED].includes(row.status))
                                || row.auditted === ACTIVITY_TYPE.PHYSICAL_AUDIT) &&
                            <Icon className="mx-2" type="button" name={hasUserAccess(USER_PRIVILEGES.REVIEWER_ACTIVITIES_AUDIT) ? 'pencil' : 'eye'}
                                text={hasUserAccess(USER_PRIVILEGES.REVIEWER_ACTIVITIES_AUDIT) ? 'Edit' : 'View'} data={row} action={editActivity} />
                        }
                    </div>
                }
            </>
        )
    }

    function ActivityTypeTmpl({ cell }: any) {
        const value = cell.getValue() || ACTIVITY_TYPE.AUDIT;
        return (
            <div className="d-flex flex-row align-items-center justify-content-center position-relative">
                <Icon name={ACTIVITY_TYPE_ICONS[value]} text={value} />
            </div>
        )
    }

    const columns = [
        {
            title: "", field: "auditted", width: 40,
            formatter: reactFormatter(<ActivityTypeTmpl />),
            // headerSort: false
        },
        {
            title: "Month & Year", field: "month", width: 140,
            formatter: reactFormatter(<MonthTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Act", field: "act.name", widthGrow: 2,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },

        {
            title: "Rule", field: "rule.name", widthGrow: 2,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Activity", field: "activity.name",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />),
            widthGrow: 2
        },
        {
            title: "Activity Type", field: "activity.activity_type",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Associate Company", field: "associate_company.name",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />),
            widthGrow: 1
        },
        {
            title: "Location Name", field: "location.name",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />),
            widthGrow: 1
        },
        {
            title: "Audit Due Date", field: "due_date", width: 120,
            formatter: reactFormatter(<DueDateTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Vendor Submitted Date", field: "submitted_date", width: 120,
            formatter: reactFormatter(<DueDateTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Compliance Status", field: "audit_status", maxWidth: 160,
            formatter: reactFormatter(<AuditStatusTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Evidence Status", field: "status", width: 160,
            formatter: reactFormatter(<FormStatusTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Actions", hozAlign: "center", width: 120,
            headerSort: false,
            formatter: reactFormatter(<ActionColumnElements />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        }
    ]

    function rowFormatter(row: any) {
        const data = row.getData();
        const element = row.getElement();
        if (data.published) {
            element.classList.add('activity-published');
        }
        if (data.auditted === ACTIVITY_TYPE.NO_AUDIT) {
            element.classList.add('activity-no-audit');
        }
    }

    const [tableConfig] = useState({
        paginationMode: 'remote',
        ajaxRequestFunc,
        columns,
        rowHeight: 'auto',
        selectable: false,
        paginate: true,
        initialSort: ['month desc'],
        rowFormatter
    });

    function formatApiResponse(list: any[], totalRecords: number) {
        const { page, per } = params || {};
        const tdata = {
            data: list,
            total: totalRecords,
            last_page: Math.ceil(totalRecords / (per || 1)) || 1,
            page: page || 1
        };
        setData(tdata);
        return tdata;
    }

    function ajaxRequestFunc(url: any, config: any, pagination_params: any) {
        const { field, dir } = (pagination_params.sort || [])[0] || {};

        const sort_column = SortFields[field] || field || 'month';
        const sort_order  = dir || 'desc';

        const _params = {
          per: pagination_params.size,
          page: pagination_params.page,
          sorts: [`${sort_column} ${sort_order}`]
        };
        setParams(_params);
        setPayload({
            ...DEFAULT_PAYLOAD,
            ..._params,
            filters: {
                ...(afRef.current || {}),
                ...(sfRef.current || {})
            },
            includes: INCLUDE_ASSOCIATIONS,
            include: INCLUDE_ASSOCIATION_COLUMNS
        });
        return Promise.resolve(formatApiResponse(activities, total));
    }

    function handlePageNav(pagination_params: any) {
        const _params: any = {
          ...params,
          per: pagination_params.per,
          page: pagination_params.page
        };
        setParams({ ..._params });
        setPayload({
          ...payload,
          ..._params,
          filters: {
              ...(afRef.current || {}),
              ...(sfRef.current || {})
          },
          includes: INCLUDE_ASSOCIATIONS,
          include: INCLUDE_ASSOCIATION_COLUMNS
        })
    }

    function getAdvanceSearchPayload() {
        const _filters = {
          ...(afRef.current || {})
        };
        return _filters;
    }


    function handleExport(event: any) {
        event.preventDefault();
        if (total < 1) {
            toast.warn('There are no records available for this filter criteria.');
            return;
        }
        const _payload = {
            ...DEFAULT_PAYLOAD,
            sorts: ['month desc'],
            ...params,
            filters: {
                ...(afRef.current || {}),
                ...(sfRef.current || {})
            }
        };
        exportTodos(_payload);
    }

    useEffect(() => {
        if (advaceSearchFilters && advaceSearchFilters.location_audit_id_eq) {
            const _params: any = { ...params, page: 1};
          setParams({ ..._params });
            setPayload({
                ...DEFAULT_PAYLOAD,
                sorts: ['month desc'],
                ..._params,
                filters: {
                    ...advaceSearchFilters,
                    ...(sfRef.current || {})
                },
                includes: INCLUDE_ASSOCIATIONS,
                include: INCLUDE_ASSOCIATION_COLUMNS
            });
        }
    }, [advaceSearchFilters]);

    useEffect(() => {
        if (advaceSearchFilters && advaceSearchFilters.location_audit_id_eq) {
            const _params: any = { ...params, page: 1};
          setParams({ ..._params });
            setPayload({
                ...DEFAULT_PAYLOAD,
                sorts: ['month desc'],
                ..._params,
                filters: {
                    ...(afRef.current || {}),
                    ...statusFilters
                },
                includes: INCLUDE_ASSOCIATIONS,
                include: INCLUDE_ASSOCIATION_COLUMNS
            });
        }
    }, [statusFilters]);

    // useEffect(()=>{
    //     const urlPath:string=window.location.pathname.split('/')[2];
    //     if(urlPath!=null){
    //         setCheckedStatuses({
    //             ...(checkedStatuses || {}),
    //             'Rejected': true
    //         });
    //     }
    // },[]);

    useEffect(() => {
        if (checkedStatuses) {
            const keys = Object.keys(checkedStatuses);
            const result = keys.filter(key => !!checkedStatuses[key]);
            const _result: any = {};
            if (result.length > 0) {
                _result['status_in'] = result;
            } else {
                _result['status_in'] = STATUS_BTNS.map(x => x.name);
            }
            setStatusFilters(_result)
        }
    }, [checkedStatuses]);

    useEffect(() => {
        if (!isFetching && payload) {
            setSelectedRows([]);
            setData(formatApiResponse(activities, total));
        }
    }, [isFetching])

    return (
        <>
            <div className="d-flex flex-column">
                <div className="d-flex p-2 align-items-center pageHeading shadow">
                    <h4 className="mb-0">Location Audits</h4>
                    <div className="d-flex align-items-end h-100">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 d-flex justify-content-end">
                                <li className="breadcrumb-item">Home</li>
                                <li className="breadcrumb-item  fw-bold active"><Link href="/location-audits" onClick={backToAuditList}>Audit Compliances</Link></li>
                                <li className="breadcrumb-item  fw-bold active">
                                Audit Details
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <form className="p-0 mx-3 my-2">
                    <div className="" style={{ fontSize: '20px', fontWeight: "600" }}>
                        <span style={{cursor: 'pointer'}} onClick={backToAuditList}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                            &nbsp;
                            Activity List
                        </span>
                        <span>
                            &nbsp;-&nbsp;
                            {(currentAudit.location || {}).name || ''}
                        </span>
                        <span>
                            &nbsp;
                            <IconButton onClick={() => setShowAuditDetails(true)} >
                            <IoMdInformationCircleOutline />
                            </IconButton>
                        </span>
                        <span className={`${AUDIT_STATUS_COLOR_CODES[currentAudit.status as keyof typeof AUDIT_STATUS_COLOR_CODES] || 'text-dark-gray'}`} style={{ fontSize: '16px', fontWeight: "500" }}>
                            &nbsp;&nbsp;
                            {AUDIT_STATUS_LABELS[currentAudit.status as keyof typeof AUDIT_STATUS_LABELS] || currentAudit.status}
                        </span>
                    </div>
                    <div className="card shadow border-0 p-2 mt-2 mb-3 filters auditFilters">
                        <div className="d-flex flex-row m-0">
                            <AuditLocationFilters onChange={search} />
                        </div>
                    </div>

                    <div className="card shadow border-0 p-2 mb-2">
                        <div className="d-flex justify-content-between">
                            <div className="d-flex align-items-center status-btn-group">
                                <label className="filter-label"><small>Forms Status</small></label>
                                {
                                    statusBtns.map(btn => {
                                        return (
                                            <div className="mx-2" key={btn.name}>
                                                <input name={btn.name} type="checkbox" className="btn-check" id={btn.name} autoComplete="off"
                                                    onChange={onFormStatusChangeHandler}
                                                    checked={checkedStatuses[btn.name]} />
                                                <label className={`btn bg-status-${btn.name}`} htmlFor={btn.name}>{btn.label}</label>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className="d-flex">
                                <div className="px-3 mx-3 d-flex flex-row align-items-center gap-2">
                                    <TableActions buttons={downloadReportButtons} btnLabel="Download Report" />
                                </div>
                                {hasUserAccess(USER_PRIVILEGES.REVIEWER_ACTIVITIES_PUBLISH) && <TableActions buttons={buttons} />}
                            </div>
                        </div>
                    </div>
                </form>
                <div className="position-relative">
                    <ActionHeaderTmpl />
                    <Table data={data} options={tableConfig} isLoading={isFetching}
                        onSelectionChange={setSelectedRows} onPageNav={handlePageNav} />
                </div>
            </div>

            {showAuditDetails && (
                <AuditDetailsModal
                onClose={() => setShowAuditDetails(false)}
                audit={currentAudit}
                auditType="location"
                />
            )}

            {
                action === ACTIONS.EDIT && Boolean(activity) &&
                <ActivityModal activity={activity} onClose={dismissAction} onSubmit={refetch} auditStatus={currentAudit.status} />
            }
            {
                !!alertMessage &&
                <AlertModal message={alertMessage} onClose={(e: any) => {
                    preventDefault(e);
                    setAlertMessage(null);
                }} />
            }
            {
                publish &&
                <PublishModal
                    onClose={() => setPublish(false)}
                    onSubmit={onPublish}
                    selectedRows={selectedRows}
                    auditType="todo"
                    audit={currentAudit}
                    auditPhase={[LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_PENDING, LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED].includes(currentAudit.status) ? "preliminary" : "final"} />
            }
            {
                action === ACTIONS.SEND_REPORT &&
                <SendEmailModal onCancel={() => setAction(ACTIONS.NONE)} />
            }
            {(submitting || exporting) && <PageLoader />}
        </>
    );
}

export default TaskManagement;
